import { styled, Switch } from '@mui/material';

/**
 * @deprecated use instead the new component
 */
export const VySwitch = styled(Switch)(() => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: '#191e39',
    '& .MuiSwitch-track': {
      backgroundColor: '#C4C7CB !important',
    },
  },
  '& .MuiSwitch-track': {
    backgroundColor: '#C4C7CB !important',
  },

  '& .MuiSwitch-switchBase.Mui-disabled': {
    '& .MuiSwitch-thumb': {
      backgroundColor: '#F4F5F7',
      boxShadow: 'none',
    },
    '& + .MuiSwitch-track': {
      backgroundColor: '#E4E7EB !important',
      opacity: 1,
    },
  },

  '& .MuiSwitch-switchBase.Mui-checked.Mui-disabled': {
    '& .MuiSwitch-thumb': {
      backgroundColor: '#A2A8B4',
      boxShadow: 'none',
    },
    '& + .MuiSwitch-track': {
      backgroundColor: '#D5D8DD !important',
      opacity: 1,
    },
  },
}));
